import { useEffect } from "react";

import { useAppSelector } from "hooks/redux_hooks";
import { PageUnloadReasonType, PubsubMessageTypeType } from "shared/types";
import { classroomSelectors, localSelectors } from "store";
import { redirectToClassEditPage } from "utils/classroom";

function MonitoringPubsubMessageObserver() {
  const classInfo = useAppSelector(classroomSelectors.selectClassInfo());
  const pubsubMessage = useAppSelector(localSelectors.selectPubsubMessage());

  useEffect(() => {
    if (!pubsubMessage || !classInfo) return;

    // This user entered the classroom on another device, let's kick them out
    if (
      pubsubMessage.type === PubsubMessageTypeType.KICK_USER_OUT_WITHOUT_WARNING &&
      pubsubMessage.data.reason === PageUnloadReasonType.KICKED_OUT_OF_CLASS_SERVER_REASSIGNMENT
    ) {
      redirectToClassEditPage(
        { classId: classInfo.id, sectionId: classInfo.section.id, courseId: classInfo.course.id },
        pubsubMessage.data.reason,
      );
    }
  }, [pubsubMessage, classInfo]);

  return null;
}

export { MonitoringPubsubMessageObserver };
